import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { FullPageState, LoadingState } from '@/components/feedback/LoadingState'
import { useAuthSession } from '@/lib/auth'

/** Destino fixo do redirect OIDC (/auth/callback). Volta para a página de origem. */
export function AuthCallbackPage() {
  const session = useAuthSession()
  const navigate = useNavigate()

  useEffect(() => {
    if (session.status === 'authenticated') navigate(session.returnTo(), { replace: true })
  }, [session, navigate])

  return (
    <FullPageState>
      <LoadingState label="Concluindo login…" />
    </FullPageState>
  )
}
